import { connect } from 'react-redux'
import { Component } from "react"
import * as THREE from 'three';
import {
    IconPlayerStopFilled,
    IconPlayerPlayFilled,
    IconDeviceFloppy,
    IconArrowDown,
    IconRotate3d,
    IconArrowLeft,
    IconArrowUpLeft,
    IconArrowRight,
    IconArrowDownRight,
    IconArrowUp,
    IconChartScatter3d,
    IconPlus,
    IconLink,
    IconMinus,
    IconXboxX
  } from '@tabler/icons-react';
import {  ActionIcon,Flex, NumberInput, LoadingOverlay, Stack,  Button, NativeSelect, CloseButton, Chip} from '@mantine/core';
import {onActionPadMode, onAdminActionCaravanserailStreetLinking} from "../../actions"

import { log } from 'three/src/nodes/TSL.js';
import { join } from 'lodash';


const initAnimation = ()=>{
    return [{"nom": "Stand", "type": "idle", "value": "", "script": ""},
    {"nom": "Walk", "type": "walk", "value": "", "script": ""},
    {"nom": "Right", "type": "goto-right", "value": "", "script": ""},
    {"nom": "Legt", "type": "goto-left", "value": "", "script": ""}]
}

const pathContext = {
   version: 0,
   timer: undefined,
   zoom: 10,
   y: 10,
   animationsList: [],
   scale:{},
   animations: initAnimation(),
   animationControler: null,
   zoomStep: 0.001,
   posStep: 0.00001,
   rotStep: 0.001,
   toSave: false,
   mode: "rotation"
}


class ActionPad extends Component{
    constructor(props) {
        super(props)
        pathContext.element3D = props.element3D
        this.state = pathContext

        this.props.notification.addNotification("zoom", async (type, msg, arg)=>{
            if(msg.container === this.props.map_id){
                const z = Math.floor(Math.round(msg.zoom))
                if(this.props.map && this.state.zoom !== z){ 
                    this.state.zoom = z
                    setTimeout(()=>this.props.map.setZoom(z), 10)
                }
            }
            else{
                
            }
            this.setState(this.state)
        });

        const t = setInterval(()=>{
            if(this.props.map !== null){
                clearInterval(t)
                this.state.zoom = this.props.map.getZoom()

                this.placeZoom(this.state.zoom)
                this.setState(this.state)
            }
        }, 100)

        const tt = setInterval(()=>{
            if(this.props.gltf !== null){
                clearInterval(tt)
                if(this.props.gltf.animations.length>0){ 
                    this.state.animationsList = ["Faite votre choix", "Script"]
                    for(let i=0; i <this.props.gltf.animations.length; i ++){
                        this.state.animationsList.push(this.props.gltf.animations[i].name)
                    }
                }
                this.setState(this.state)
            }
        }, 100)

    }

    changeMode(){
        if(this.state.mode === "position"){
            this.state.mode = "rotation"
        }
        else{
            this.state.mode = "position"
        }
        this.setState(this.state)
    }
    onMouseDown(what){
        console.log("ActionPad.onMouseDown", what)
        if(!this.props.gltf) return;

        if(what === "up"){
            //this.props.gltf.scene.rotateX(  this.state.rotStep)
            this.state.toSave = true
            this.setState(this.state)
            this.state.timer = setInterval(()=>{
                if(this.state.mode === "rotation") this.props.gltf.scene.rotateX(  this.state.rotStep)
                else {
                    this.props.element3D.lngLat.lat += this.state.posStep
                    let {x: x, y:y, z:z} = this.props.map.getPosition3D(this.props.element3D.lngLat)
                    this.props.gltf.scene.position.set(x, this.props.gltf.scene.position.y, z)
                }
                this.updateInnerAttributes()
            }, 1)
            this.updateInnerAttributes()
        }
        if(what === "upLeft"){
            //this.props.gltf.scene.rotateX(  this.state.rotStep)
            this.state.toSave = true
            this.setState(this.state)
            this.state.timer = setInterval(()=>{
                if(this.state.mode === "rotation") this.props.gltf.scene.rotateZ(  this.state.rotStep)
                this.updateInnerAttributes()
            }, 1)
            this.updateInnerAttributes()
        }
        if(what === "down"){
            //this.props.gltf.scene.rotateX(  -this.state.rotStep)
            this.state.toSave = true
            this.setState(this.state)
            this.state.timer = setInterval(()=>{
                if(this.state.mode === "rotation") this.props.gltf.scene.rotateX(  -this.state.rotStep)
                else {
                    this.props.element3D.lngLat.lat -= this.state.posStep
                    let {x: x, y:y, z:z} = this.props.map.getPosition3D(this.props.element3D.lngLat)
                    this.props.gltf.scene.position.set(x, this.props.gltf.scene.position.y, z)
                    //this.props.gltf.scene.position.set(this.props.gltf.scene.position.x, this.props.gltf.scene.position.y, this.props.gltf.scene.position.z - 1)
                }
                this.updateInnerAttributes()
            }, 1)
            this.updateInnerAttributes()
        }

        if(what === "left"){
            //this.props.gltf.scene.rotateY(  this.state.rotStep)
            this.state.toSave = true
            this.setState(this.state)
            this.state.timer = setInterval(()=>{
                if(this.state.mode === "rotation") this.props.gltf.scene.rotateY(  this.state.rotStep)
                else {
                    this.props.element3D.lngLat.lng -= this.state.posStep
                    let {x: x, y:y, z:z} = this.props.map.getPosition3D(this.props.element3D.lngLat)
                    this.props.gltf.scene.position.set(x, this.props.gltf.scene.position.y, z)
                    //this.props.gltf.scene.position.set(this.props.gltf.scene.position.x + 1, this.props.gltf.scene.position.y, this.props.gltf.scene.position.z)
                }
                this.updateInnerAttributes()
            }, 1)
            this.updateInnerAttributes()
        }
        if(what === "right"){
            //this.props.gltf.scene.rotateY(  -this.state.rotStep)
            this.state.toSave = true
            this.setState(this.state)
            this.state.timer = setInterval(()=>{
                if(this.state.mode === "rotation") this.props.gltf.scene.rotateY(  -this.state.rotStep)
                else {

                    this.props.element3D.lngLat.lng += this.state.posStep
                    let {x: x, y:y, z:z} = this.props.map.getPosition3D(this.props.element3D.lngLat)
                    this.props.gltf.scene.position.set(x, this.props.gltf.scene.position.y, z)

                    //this.props.gltf.scene.position.set(this.props.gltf.scene.position.x - 1, this.props.gltf.scene.position.y, this.props.gltf.scene.position.z)
                }
                this.updateInnerAttributes()
            }, 1)
            this.updateInnerAttributes()
        }
        if(what === "downRight"){
            this.props.gltf.scene.rotateY(  -this.state.rotStep)
            this.state.toSave = true
            this.setState(this.state)
            this.state.timer = setInterval(()=>{
                if(this.state.mode === "rotation") this.props.gltf.scene.rotateZ(  -this.state.rotStep)
                this.updateInnerAttributes()
            }, 1)
            this.updateInnerAttributes()
        }
        

    }

    onMouseUp(what){
        clearInterval(this.state.timer)
    }

    onZoomeDown(what){
        let p = -this.state.zoomStep
        if(what === "+") p = this.state.zoomStep

        const s = this.props.gltf.scene.scale
        this.props.gltf.scene.scale.set(s.x + p, s.y + p, s.z + p)
        this.state.scale[this.state.zoom] = {x: this.props.gltf.scene.scale.x, z: this.props.gltf.scene.scale.z, y: this.props.gltf.scene.scale.y}
        this.state.toSave = true
        this.setState(this.state)
        this.state.timer = setInterval(()=>{
            const s = this.props.gltf.scene.scale
            this.props.gltf.scene.scale.set(s.x + p, s.y + p, s.z + p)
            this.state.scale[this.state.zoom] = {x: this.props.gltf.scene.scale.x, z: this.props.gltf.scene.scale.z, y: this.props.gltf.scene.scale.y}
            this.state.toSave = true
            this.setState(this.state)
        }, 15)
    }

    onZoomeUp(what){
        clearInterval(this.state.timer)
    }

    updateInnerAttributes(){
        if(!this.props.gltf) return
        const scale = this.props.gltf.scene.scale
        if(!this.state.parameters){
            this.state.parameters = {}
        }
        this.state.parameters.scale = {x: scale.x, y: scale.y, z: scale.z}
        this.state.parameters.y = this.state.y
        this.state.parameters.rotate = {x: this.props.gltf.scene.rotation.x, y: this.props.gltf.scene.rotation.y, z: this.props.gltf.scene.rotation.z}
        this.state.parameters.lngLat = new window.maplibregl.LngLat(this.props.element3D.lngLat.lng , this.props.element3D.lngLat.lat)
        this.state.toSave = true
        this.setState(this.state)
        this.props.notification.onNotification("Object3DParametresChange", {element_id: this.props.element3D.id||this.props.element3D.uid, type: this.props.element3D.element3D.type, parameters: this.state.parameters}, {})
    }

    stopAnimation(){
        if(!this.state.animationControler) return 

        if(this.state.animationControler ){
            
            this.state.animationControler.action.stop()
            clearInterval(this.state.animationControler.timer)
            this.state.animationControler = null
            this.setState(this.state)
        }
    }
    playAnimation(element3d, animation){
        this.stopAnimation()
        
        if(!this.state.animationControler){

            const clip = THREE.AnimationClip.findByName( element3d.animations, animation.name )//
            if(clip){ 
                const mixer = new THREE.AnimationMixer( element3d.scene );
                const action = mixer.clipAction( clip )

                this.state.animationControler = {
                    action: action,
                    mixer: mixer,
                    clip: clip,
                    animation: animation,
                    timer: setInterval(()=>this.doAnimation(), 10)
                }
                action.play()
            }

        } else {
            this.state.animationControler.action.play()
        }
        this.setState(this.state)
    }

    doAnimation(){

        if(this.state.animationControler){
            this.state.animationControler.mixer.update(1/120)
        }
    }

    placeZoom(z){

        if(this.state.scale[z]){ 
            this.props.gltf.scene.scale.set(this.state.scale[z].x, this.state.scale[z].y, this.state.scale[z].z)
        }
        else{
            for(z; z < 20; z++){
                if(this.state.scale[z]){ 
                    this.props.gltf.scene.scale.set(this.state.scale[z].x, this.state.scale[z].y, this.state.scale[z].z)
                    break
                }
            }
        }
    }

    save() {
        this.state.loading = true
        this.setState(this.state)
        const parameters = {
            "animations": this.state.animations,
            "y": this.state.y,
            "scale": this.state.scale,
            "rotate": {x: this.props.gltf.scene.rotation.x, z: this.props.gltf.scene.rotation.z, y: this.props.gltf.scene.rotation.y}
        }

        const uri = "/update/mesh3d/parameters/" + this.props.element3D.id
        fetch(uri, {
            method: "POST",
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            parameters: parameters
        })
        }).then(async (response) => { 
            if(response.status === 200) { 
                this.state.toSave = false
                this.props.element3D.parameters = parameters
            }
            this.state.loading = false
            this.setState(this.state)
        })
    }

    closePad() {
        this.props.notification.onNotification("Object3DClearSelection", {}, {})
    }
    async linkRoad(){

        const self = this;
        //this.props.pathSelected

        /*const parameters = {
            "path": this.props.pathSelected.path
        }*/

        const uri = "/object3D/link/" + this.props.element3D.uid + "/" + this.props.pathSelected.node.point.uid
        fetch(uri, {
            method: "POST",
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            path: this.props.pathSelected.path.uid
        })
        }).then(async (response) => { 
            if(response.status === 200) {
                self.props.onAdminActionCaravanserailStreetLinking(undefined)
            }
        })

    }
    render(){
        if(this.props.map && this.props.gltf && this.props.gltf.animations.length>0){ 
            const l = this.state.animationsList.join(",")
            let t = "Faite votre choix,Script"
            let sep = ","
            for(let i=0; i <this.props.gltf.animations.length; i ++){
                t += sep + this.props.gltf.animations[i].name
                
               
            }
            if(t !== l){
                this.state.animationsList = ["Faite votre choix", "Script"]
                for(let i=0; i <this.props.gltf.animations.length; i ++){
                    this.state.animationsList.push(this.props.gltf.animations[i].name)
                }
                if(this.props.element3D && this.props.element3D.parameters && this.props.element3D.parameters.animations)
                {
                    this.state.animations = this.props.element3D.parameters.animations
                }
                else this.state.animations = initAnimation()
                setTimeout(()=>{
                    this.props.map.setZoom(16)
                    this.state.zoom  = 16
                    this.state.scale[this.state.zoom ] = {x: this.props.gltf.scene.scale.x, z: this.props.gltf.scene.scale.z, y: this.props.gltf.scene.scale.y}

                    if(this.props.element3D && this.props.element3D.parameters){
                        if(this.props.element3D.parameters.animations){
                            this.state.animations = this.props.element3D.parameters.animations
                        }
                        if(this.props.element3D.parameters.y){
                            this.state.y = this.props.element3D.parameters.y
                        }
                        if(this.props.element3D.parameters.scale){
                            this.state.scale = this.props.element3D.parameters.scale
                        }
                        if(this.props.element3D.parameters.rotate){
                            this.state.rotate = this.props.element3D.parameters.rotate
                        }
                    }

                    this.setState(this.state)
                }, 1)
                
            }
        }


        return (
        <>
            <LoadingOverlay visible={this.state.loading} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
            <div className={"actionPad " + this.props.position}>
                
                <Flex bg="rgba(0, 0, 0, .3)" direction="column" className="radius padding" gap="sm">
                    <CloseButton onClick={()=>{this.closePad()}} icon={<IconXboxX size={18} stroke={1.5} />} style={{"zIndex":"2", "position": "absolute", "right": "0.5rem", "top": "0.5rem"}} />
                    {this.props.element3D ? (<Chip className='uid'>{this.props.element3D.uid}</Chip>) : ""}
                    <Flex justify="center" align="center" gap="sm" className={this.state.mode === "rotation" ? 'padd down': ""}>
                        {
                            this.state.mode === "rotation" ? <ActionIcon onMouseDown={(e)=>{this.onMouseDown("upLeft")}} onMouseUp={(e)=>{this.onMouseUp("upLeft")}} size="xl" radius="sm" variant="filled"> <IconArrowUpLeft size={26} stroke={1.5} /></ActionIcon>: ""
                        }
                        <ActionIcon onMouseDown={(e)=>{this.onMouseDown("up")}} onMouseUp={(e)=>{this.onMouseUp("up")}} size="xl" radius="sm" variant="filled"> <IconArrowUp size={26} stroke={1.5} /></ActionIcon>
                    </Flex>
                    <Flex justify="center" align="center"  gap="sm">
                        <ActionIcon onMouseDown={(e)=>{this.onMouseDown("left")}} onMouseUp={(e)=>{this.onMouseUp("left")}} size="xl" radius="sm" variant="filled"> <IconArrowLeft size={26} stroke={1.5} /></ActionIcon>
                        {
                            this.state.mode === "rotation" ? 
                                <ActionIcon  radius="sm" class="outline" onClick={()=>{this.changeMode()}}> <IconRotate3d size={26} stroke={1.5} /></ActionIcon> :
                                <ActionIcon  radius="sm" class="outline" onClick={()=>{this.changeMode()}}> <IconChartScatter3d size={26} stroke={1.5} /></ActionIcon>
                        }
                        
                        <ActionIcon size="xl" onMouseDown={(e)=>{this.onMouseDown("right")}} onMouseUp={(e)=>{this.onMouseUp("right")}} radius="sm" variant="filled"> <IconArrowRight size={26} stroke={1.5} /></ActionIcon>
                    </Flex>
                    <Flex justify="center" align="center" gap="sm" className={this.state.mode === "rotation" ? 'padd down': ""}> 
                        
                        <ActionIcon onMouseDown={(e)=>{this.onMouseDown("down")}} onMouseUp={(e)=>{this.onMouseUp("down")}}  size="xl" radius="sm" variant="filled"> <IconArrowDown size={26} stroke={1.5} /></ActionIcon>
                        { this.state.mode === "rotation" ?  <ActionIcon onMouseDown={(e)=>{this.onMouseDown("downRight")}} onMouseUp={(e)=>{this.onMouseUp("downRight")}}  size="xl" radius="sm" variant="filled"> <IconArrowDownRight size={26} stroke={1.5} /></ActionIcon>: ""}

                       
                    </Flex>

                    
                    <NumberInput
                                size="xs"
                                clampBehavior="strict"
                                placeholder={this.state.posStep}
                                value={this.state.posStep}
                                onChange={(s)=>{
                                        const step = parseFloat(s)
                                        if(this.state.mode === "position"){
                                            this.state.posStep = step
                                        }
                                        else{
                                            this.state.rotStep = step
                                        }
                                        
                                        this.setState(this.state)
                                    }
                                }
                                />
                    { 
                        this.props.pathSelected ? (<Button rightSection={<IconLink size={14} />} onClick={()=>{this.linkRoad()}}>Linker au chemin</Button>):""
                    }
                </Flex>
                
                <Flex bg="rgba(0, 0, 0, .3)" direction="column" className="radius padding" gap="sm">
                    <Flex justify="center" align="center"  gap="sm">
                        <ActionIcon onMouseDown={(e)=>{this.onZoomeDown("-")}} onMouseUp={(e)=>{this.onZoomeUp("-")}} size="xl" radius="sm" variant="filled"> <IconMinus size={26} stroke={1.5} /></ActionIcon>
                        <NumberInput
                            size="xs"
                            clampBehavior="strict"
                            min={ this.props.map ? this.props.map.getMinZoom():10} max={this.props.map ? this.props.map.getMaxZoom(): 16}
                            placeholder={this.state.zoom}
                            value={this.state.zoom}
                            step={1}
                            onChange={(zoom)=>{
                                    const z = Math.floor(Math.round(parseFloat(zoom)))
                                    this.props.map.setZoom(z)
                                    this.state.zoom = z
                                    this.placeZoom(z)
                                    //this.state.scale[z] = {x: this.props.gltf.scene.scale.x, z: this.props.gltf.scene.scale.z, y: this.props.gltf.scene.scale.y}
                                    this.setState(this.state)
                                }
                            }
                            />

                            <NumberInput
                                size="xs"
                                clampBehavior="strict"
                                placeholder={this.state.zoomStep}
                                value={this.state.zoomStep}
                                onChange={(zoom)=>{
                                        const z = parseFloat(zoom)
                                        this.state.zoomStep = z
                                        this.setState(this.state)
                                    }
                                }
                                />  
                        <ActionIcon onMouseDown={(e)=>{this.onZoomeDown("+")}} onMouseUp={(e)=>{this.onZoomeUp("+")}}  size="xl" radius="sm" variant="filled"> <IconPlus size={26} stroke={1.5} /></ActionIcon>
                    </Flex>
                    
                </Flex>
                { 
                    this.props.gltf ? (<div className={"action-pad-animation"}>
                        <Flex   gap="sm">
                            <span>Z:</span>
                            <NumberInput
                                size="xs"
                                clampBehavior="strict"
                                
                                placeholder={this.props.gltf.scene.position.y}
                                value={this.props.gltf.scene.position.y}
                                onChange={(z)=>{
                                        const y = parseInt(z)
                                        this.props.gltf.scene.position.set(this.props.gltf.scene.position.x, y, this.props.gltf.scene.position.z)
                                        this.state.y = y
                                        this.state.toSave = true
                                        this.setState(this.state)
                                        this.updateInnerAttributes()
                                    }
                                }
                                />
                        </Flex>
                    </div>): ""
                }
                {
                    this.props.gltf && this.props.gltf.animations.length>0  && this.state.animations.length > 0? (
                        (
                            <div className={"action-pad-animation"}>

                                <Stack h={300} align="stretch" justify="center" gap="md">
                                { 
                                    this.state.animations.map((animation, pos)=>(
                                        <Flex   gap="sm">
                                            <span>{animation.nom}</span>
                                            <NativeSelect placeholder={animation.nom} data = {this.state.animationsList} value={animation.value} onChange={(e)=>{
                                                this.stopAnimation()
                                                if(e.target.value === this.state.animationsList[0])  animation.value=""
                                                else animation.value= e.target.value

                                                this.state.toSave = true
                                                this.setState(this.state)
                                            }}/>
                                            {
                                                animation.value !== "" ? (
                                                    <ActionIcon variant="filled" aria-label="Settings" onClick={()=>{
                                                    }}>
                                                    {this.state.animationControler && this.state.animationControler.animation.name === animation.value? 
                                                    (<IconPlayerStopFilled size={14} onClick={()=>{this.stopAnimation()}}/>) : 
                                                    (<IconPlayerPlayFilled size={14} onClick={()=>{
                                                        for(var i=0; i < this.props.gltf.animations.length; i ++){ 
                                                            if(this.props.gltf.animations[i].name === animation.value){ 
                                                                this.playAnimation(this.props.gltf, this.props.gltf.animations[i])
                                                                break;
                                                            }
                                                        }
                                                    }}/>)}
                                                    </ActionIcon>
                                                ):'' 
                                            }
                                        </Flex>
                                    ))
                                }
                                    
                                </Stack>
                                
                            </div>
                        )
                    ): ""
                }
                
                
                
            </div>
            
            {
                this.state.toSave === true && this.props.mode !== "instance" ?(<Button style={{ "width": "8rem", "zIndex":"2", "marginTop": "1rem", "position": "absolute", "right": "2rem", "bottom": "2rem"}} rightSection={<IconDeviceFloppy size={14} />} onClick={()=>{this.save()}}>Sauvegarde</Button>):""
            }
        </>
        )
    }

}
const mapDispatchToProps = {
    onActionPadMode: onActionPadMode,
    onAdminActionCaravanserailStreetLinking: onAdminActionCaravanserailStreetLinking
}

const mapStateToProps = (state) => {  
    const actionPadMode = state.actionPadMode ? state.actionPadMode : "position"
    return {
        editMode: state.editMode,
        notification: state.notification,
        actionPadMode: state.actionPadMode,
        pathSelected: state.pathSelected
    }
}


ActionPad = connect(mapStateToProps, mapDispatchToProps)(ActionPad);

export default ActionPad;
